import React from 'react';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Title from '../shared/Title';
import Spinner from '../shared/Spinner';
import Charts from './Charts/Charts';
import ItemSelector from '../shared/ItemSelector';
import Boxscore from './Boxscore/Boxscore';
import ShotCharts from './ShotCharts/ShotCharts';
import { ExternalLink } from '../shared/Links';

import { getAccessToken } from '../../lib/crossover.js';
import { createOverflow } from '../../lib/format';
import { useProfile } from '../shared/hooks';

const getExportLink = gameId => {
  const accessToken = getAccessToken();
  return `/api/stats/game/${gameId}/lineup?print=1&token=${accessToken}`;
};

const GameExplorer = ({
  team,
  stats,
  gameSelector,
  gameNavigation,
  pathTo,
  season,
  boxscore,
  shotCharts,
  shiftLocked,
}) => {
  const overflow = createOverflow(team, season);
  const profile = useProfile();
  const isSilver = profile?.tier.startsWith('SILVER');

  return (
    <div className="s-game-explorer">
      <Title
        team={team}
        linkTo={pathTo('team')}
        subtitle={'Game Explorer'}
        overflow={overflow}
      />

      <div className="action-bar">
        <div>
          <div className="s-game-explorer__navigate">
            {
              <Link
                className="btn-info"
                to={pathTo('game-explorer', gameNavigation.prevId)}
                disabled={!gameNavigation.prevId}
              >
                Previous
              </Link>
            }

            {
              <Link
                className="btn-info"
                to={pathTo('game-explorer', gameNavigation.nextId)}
                disabled={!gameNavigation.nextId}
              >
                Next
              </Link>
            }

            {!isSilver && (
              <ExternalLink
                className="btn-info"
                href={getExportLink(gameNavigation.thisId)}
                title="Export"
              >
                Export
              </ExternalLink>
            )}
          </div>
        </div>

        <ItemSelector
          className="s-game-explorer__game-selector"
          {...gameSelector}
        />
      </div>

      {shiftLocked && (
        <div class="s-game-explorer__warning">
          <div>
            Shift Analysis for this game is unavailable due to incomplete source
            data.
          </div>
          <div>For more information, contact an administrator.</div>
        </div>
      )}

      {stats ? (
        <Tabs
          defaultIndex={shiftLocked || stats.home_shifts.length === 0 ? 1 : 0}
        >
          <TabList className="nav-pills">
            <Tab className="nav-pills__item" disabled={shiftLocked}>
              Shift Analysis
            </Tab>
            <Tab className="nav-pills__item">Box Scores</Tab>
            <Tab
              className="nav-pills__item"
              disabled={!shotCharts || shotCharts.length === 0}
            >
              Shot Charts
            </Tab>
          </TabList>

          <TabPanel>
            <Charts pathTo={pathTo} stats={stats} team={team} />
          </TabPanel>
          <TabPanel>
            {boxscore ? <Boxscore boxscore={boxscore} /> : <Spinner />}
          </TabPanel>
          <TabPanel>
            <ShotCharts shotCharts={shotCharts} />
          </TabPanel>
        </Tabs>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
export default GameExplorer;
